import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { environment } from '../../environments/environment';

export interface ErrorInterface {
  level: string;
  text: string;
  counter?: number;
}

@Injectable()
export class ErrorService {

  private errorObserver = new Subject<any>();
  public onError = this.errorObserver.asObservable();

  public errors: Array<ErrorInterface> = [];

  constructor() {
  };

  public logError(level: any, text: any): void {
    const now = new Date(new Date().valueOf() + environment.SERVER_TZ_OFFSET * 1000);
    const errorTimestamp = now.toISOString().replace('T', ' ').replace('Z', ' MSK');
    console.log('[' + level + '] @ ' + errorTimestamp + ' > ' + text);
    this.errorObserver.next({ level: level, text: text, counter: 1 });

    switch (level) {
      case 'debug':
        break;
      default:
        this.errors.push({ level: level, text: text });
        break;
    };

  };

}



// WEBPACK FOOTER //
// ./src/app/errorbar/error.service.ts